import { takeLatest, call, put, all } from "redux-saga/effects";
import {
  CREATE_QUEUE_RECORD,
  UPDATE_QUEUE_RECORD,
  DELETE_QUEUE_RECORD,
  GET_QUEUE_RECORD,
  LIST_QUEUE_RECORDS,
  createQueueRecordSuccess,
  createQueueRecordFailure,
  updateQueueRecordSuccess,
  updateQueueRecordFailure,
  deleteQueueRecordSuccess,
  deleteQueueRecordFailure,
  getQueueRecordSuccess,
  getQueueRecordFailure,
  listQueueRecordsSuccess,
  listQueueRecordsFailure,
} from "../actions/queueServicesActions";
import {
  createQueueRecordApi,
  updateQueueRecordApi,
  deleteQueueRecordApi,
  getQueueRecordApi,
  listQueueRecordsApi,
} from "../apis/queueServicesApi";

// Saga to handle creating a queue record
function* initiateCreateQueueRecord(action) {
  try {
    console.log(
      `PMM - SF - queueServicesSaga.js - initiateCreateQueueRecord - action is: ${JSON.stringify(
        action
      )}`
    );

    const queueRecordInput = action.payload;
    console.log(
      `PMM - SF - queueServicesSaga.js - initiateCreateQueueRecord - queueRecordInput is: ${JSON.stringify(
        queueRecordInput
      )}`
    );

    const response = yield call(createQueueRecordApi, queueRecordInput);
    console.log(
      `PMM - SF - queueServicesSaga - response is: ${JSON.stringify(response)}`
    );
    // Dispatch the success action with the returned response
    yield put(createQueueRecordSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(createQueueRecordFailure(error.message));
  }
}

// Saga to handle updating a queue record
function* initiateUpdateQueueRecord(action) {
  try {
    const response = yield call(updateQueueRecordApi, action.payload);
    // Dispatch the success action with the updated response
    yield put(updateQueueRecordSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(updateQueueRecordFailure(error.message));
  }
}

// Saga to handle deleting a queue record
function* initiateDeleteQueueRecord(action) {
  try {
    const { id } = action.payload;
    const response = yield call(deleteQueueRecordApi, id);
    // Dispatch the success action with a success message
    yield put(deleteQueueRecordSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(deleteQueueRecordFailure(error.message));
  }
}

// Saga to handle retrieving a single queue record
function* initiateGetQueueRecord(action) {
  try {
    const { id } = action.payload;
    const response = yield call(getQueueRecordApi, id);
    // Dispatch the success action with the retrieved queue record
    yield put(getQueueRecordSuccess(response.getQueueRecord));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(getQueueRecordFailure(error.message));
  }
}

// Saga to handle listing queue records
function* initiateListQueueRecords(action) {
  try {
    const { limit, nextToken } = action.payload;
    const response = yield call(listQueueRecordsApi, limit, nextToken);
    // Dispatch the success action with the queue records connection
    yield put(listQueueRecordsSuccess(response.listQueueRecords));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(listQueueRecordsFailure(error.message));
  }
}

// Watcher saga for creating a queue record
function* watchInitiateCreateQueueRecord() {
  yield takeLatest(CREATE_QUEUE_RECORD, initiateCreateQueueRecord);
}

// Watcher saga for updating a queue record
function* watchInitiateUpdateQueueRecord() {
  yield takeLatest(UPDATE_QUEUE_RECORD, initiateUpdateQueueRecord);
}

// Watcher saga for deleting a queue record
function* watchInitiateDeleteQueueRecord() {
  yield takeLatest(DELETE_QUEUE_RECORD, initiateDeleteQueueRecord);
}

// Watcher saga for retrieving a queue record
function* watchInitiateGetQueueRecord() {
  yield takeLatest(GET_QUEUE_RECORD, initiateGetQueueRecord);
}

// Watcher saga for listing queue records
function* watchInitiateListQueueRecords() {
  yield takeLatest(LIST_QUEUE_RECORDS, initiateListQueueRecords);
}

// Root saga that bundles all queue services watchers
export default function* queueServicesSaga() {
  yield all([
    watchInitiateCreateQueueRecord(),
    watchInitiateUpdateQueueRecord(),
    watchInitiateDeleteQueueRecord(),
    watchInitiateGetQueueRecord(),
    watchInitiateListQueueRecords(),
  ]);
}
